import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Alert,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { theme } from "../../styles/themes/mainTheme";
import { FC } from "react";

interface PasswordResetDialogProps {
    isOpen: boolean;
    onClose: () => void;
    isPwdResetSuccessVisible: boolean;
    isPwdResetErrorVisible: boolean;
    onResetPassword: () => void;
}

const PasswordResetDialog: FC<PasswordResetDialogProps> = ({
    isOpen,
    onClose,
    isPwdResetSuccessVisible,
    isPwdResetErrorVisible,
    onResetPassword,
}) => {
    const { t } = useTranslation();
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {isPwdResetSuccessVisible && (
                <Alert severity="success" sx={{ marginBottom: "1em" }}>
                    {t("table.user.resetPasswordValidationMessage")}
                </Alert>
            )}
            {isPwdResetErrorVisible && (
                <Alert severity="error" sx={{ marginBottom: "1em" }}>
                    {t("table.user.resetPasswordErrorMessage")}
                </Alert>
            )}

            <DialogTitle id="alert-dialog-title">
                {t("table.user.resetPassword")}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {t("table.user.resetPasswordConfirmationText")}
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    sx={{
                        color: theme.palette.text.secondary,
                    }}
                >
                    {t("header.cancel")}
                </Button>
                <Button onClick={onResetPassword} autoFocus>
                    {t("header.continue")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PasswordResetDialog;
